<main role="main" class="not-home-page">
    <div class="row">  
      <div class="container">
         <div class="row">
           <div class="col-md-12">
             <div class="banner"><img src="" alt=""></div>
             <app-breadcrumb></app-breadcrumb>            
             <h2>Lexique</h2>
           </div>
           <div class="col-md-3 side-bar">
            <div class="selected-item">      </div>   
             <nav id="sidebar">
               <app-statique-menu [lg]="currentLg" [cururl]="'/acces-rapide/lexique'"></app-statique-menu>
             </nav>
           </div>
           <div class="col-md-9">       
             <section class="content-side">
               <div class="container">
                 <div class="row">
                   <div class="col-md-12">
                       <div class= "row">
                        <div  style="display: inline-flex;" class="letter col-12"> 
                            <div *ngFor="let item of alphArray" style=" width:3.8%">
                                <a  href="javascript:void(0)" (click)="alphabet=item.toUpperCase()">{{item.toUpperCase()}}</a>
                            </div>
                           
                         </div>
                       </div>
                       <div  style="margin-bottom: 15px;">
                        
                        <div class="content" *ngFor="let item of lexiques | filterAlpha:alphabet">
                         <p class="title">{{item.Title}}</p>
                         <div >
                             <p>{{item.Descriptif}}</p>
                            </div>
                        </div>

                       </div>
                    
                  </div>
               </div>
            </div>
             </section>
            </div>
         </div>
      </div>
   </div>
   </main>